'use client'

import { createContext, useContext } from 'react'

export type ContextMenuInteractionMode = 'menu' | 'dialog'

const ContextMenuInteractionContext = createContext<ContextMenuInteractionMode>('menu')

export const ContextMenuInteractionProvider = ContextMenuInteractionContext.Provider

export function useContextMenuInteractionMode(): ContextMenuInteractionMode {
    return useContext(ContextMenuInteractionContext)
}
